var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.2,
    x2: 411.076,
    xlinkHref: "#lg1",
    y1: 108.2,
    y2: 411.076
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.957,
    x2: 16.398,
    xlinkHref: "#lg2",
    y1: 147.765,
    y2: -124.794
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.392,
    x2: 146.392,
    xlinkHref: "#lg3",
    y1: 304.77,
    y2: 492.115
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.275,
    x2: -14.725,
    y1: 338.295,
    y2: 63.295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.627,
    x2: 277.224,
    y1: 105.373,
    y2: 188.971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.675,
    x2: 335.675,
    y1: 306.649,
    y2: 363.649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.678,
    x2: 131.495,
    y1: 156.322,
    y2: 204.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.769,
    x2: 11.418,
    y1: 232.231,
    y2: 71.88
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.062,
    x2: 466.594,
    y1: 200.938,
    y2: 298.471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.873,
    x2: 429.497,
    y1: 347.127,
    y2: 396.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.204,
    x2: 445.893,
    y1: 95.796,
    y2: 149.485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.164,
    x2: 113.82,
    xlinkHref: "#lg1",
    y1: 93.86,
    y2: 160.516
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 414.543,
    y2: 491.2
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.378,
    x2: 179.065,
    xlinkHref: "#lg3",
    y1: 294.623,
    y2: 375.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.85 47.312h-354.779c-10.177 0-19.937 4.043-27.133 11.239l-83.699 83.699c-7.196 7.196-11.239 16.956-11.239 27.133v260.155c0 18.232 14.917 33.15 33.15 33.15h443.711c18.227 0 33.139-14.913 33.139-33.139v-349.087c0-18.232-14.917-33.15-33.15-33.15z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.85 47.312h-354.779c-10.177 0-19.937 4.043-27.133 11.239l-83.699 83.699c-5.339 5.339-8.937 12.091-10.441 19.375l301.062 301.062h175.001c18.227 0 33.139-14.913 33.139-33.139v-349.086c0-18.232-14.917-33.15-33.15-33.15z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m223.068 422.433h-153.351c-10.337 0-18.717-8.38-18.717-18.717v-122.158c0-10.337 8.38-18.717 18.717-18.717h153.351c10.337 0 18.717 8.38 18.717 18.717v122.159c-.001 10.336-8.38 18.716-18.717 18.716z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.068 262.841h-121.055l139.771 139.771v-121.054c0-10.337-8.379-18.717-18.716-18.717z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.292 247.159h-153.352c-10.337 0-18.717-8.38-18.717-18.717v-122.159c0-10.337 8.38-18.717 18.717-18.717h153.351c10.337 0 18.717 8.38 18.717 18.717v122.159c0 10.337-8.379 18.717-18.716 18.717z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.292 422.433h-50.003c-10.337 0-18.717-8.38-18.717-18.717v-122.158c0-10.337 8.38-18.717 18.717-18.717h50.003c10.337 0 18.717 8.38 18.717 18.717v122.159c-.001 10.336-8.38 18.716-18.717 18.716z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.719 247.159h-50.002c-10.337 0-18.717-8.38-18.717-18.717v-106.159c0-19.173 15.543-34.717 34.717-34.717h34.003c10.337 0 18.717 8.38 18.717 18.717v122.159c-.001 10.337-8.381 18.717-18.718 18.717z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.719 87.567h-34.002c-19.174 0-34.717 15.543-34.717 34.716v89.545l35.331 35.331h33.389c10.337 0 18.717-8.38 18.717-18.717v-122.159c-.001-10.336-8.381-18.716-18.718-18.716z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.283 326.955h-50.003c-10.337 0-18.717-8.38-18.717-18.717v-122.159c0-10.337 8.38-18.717 18.717-18.717h50.003c10.337 0 18.717 8.38 18.717 18.717v122.159c0 10.337-8.38 18.717-18.717 18.717z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.283 422.433h-50.003c-10.337 0-18.717-8.38-18.717-18.717v-42.363c0-10.337 8.38-18.717 18.717-18.717h50.003c10.337 0 18.717 8.38 18.717 18.717v42.363c0 10.337-8.38 18.717-18.717 18.717z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.283 150.182h-50.003c-10.337 0-18.717-8.38-18.717-18.717v-25.182c0-10.337 8.38-18.717 18.717-18.717h50.003c10.337 0 18.717 8.38 18.717 18.717v25.182c0 10.338-8.38 18.717-18.717 18.717z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.137 160.074c-.123.533-.236 1.052-.339 1.552h101.537c7.19 0 13.018-5.828 13.018-13.018v-100.691c-.794.141-1.628.307-2.487.497-7.569 1.674-14.47 5.566-19.952 11.047l-80.748 80.748c-5.46 5.459-9.294 12.342-11.029 19.865z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 397.387v32.151c0 18.232 14.917 33.15 33.15 33.15h443.711c18.227 0 33.139-14.913 33.139-33.139v-32.161h-510z",
    fill: "url(#SVGID_13_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m223.068 422.433h-153.351c-10.337 0-18.717-8.38-18.717-18.717v-122.158c0-10.337 8.38-18.717 18.717-18.717h153.351c10.337 0 18.717 8.38 18.717 18.717v122.159c-.001 10.336-8.38 18.716-18.717 18.716z",
    fill: "url(#SVGID_14_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.4883ab89703ef188a5e97a4ffd646171.svg";
export { ForwardRef as ReactComponent };